import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

const PopperStyled = styled(Popper)(({ theme }) => ({
	overflow: 'visible',
	zIndex: 1202,
	minWidth: 180,
	'&:before': {
		content: '""',
		display: 'block',
		position: 'absolute',
		top: 5,
		left: 32,
		width: 12,
		height: 12,
		transform: 'translateY(-50%) rotate(45deg)',
		zIndex: 120,
		borderWidth: '6px',
		borderStyle: 'solid',
		borderColor: `${theme.palette.background.paper}  transparent transparent ${theme.palette.background.paper}`,
	},
}));

export default PopperStyled;
